<template>
  <div class="home">
    <router-link to="/search?from=home&event=搜索" tag="div" class="search">
      <img src="../../assets/images/search.png" alt="" />
    </router-link>
    <div class="welcome fvl">
      <img src="../../../public/logo.png" />
      <span>尊贵的奔驰车主{{ username }}，{{ meridiemStr }}好 !</span>
    </div>
    <div class="choiceBox">
      <SubTitle :datas="choiceProductTitle" @click="linkTo('/shop', { event: '精选商品列表', categoryCode: 'all' })" />
      <ChoiceProduct :datas="menuLis" />
    </div>

    <div class="bottomContent">
      <SubTitle :datas="ticket" @click="linkTo('/couponCollection', { event: '更多好券' })" />
      <DiscountCoupon :datas="couponList" />
    </div>
    <BackTop />
    <CompleteInfoPopup />
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import SubTitle from '@/components/common/SubTitle.vue'
import DiscountCoupon from '@/components/home/DiscountCoupon.vue'
import ChoicenessList from '@/components/home/ChoicenessList.vue'
import CompleteInfoPopup from '@/components/home/CompleteInfoPopup.vue'
import ChoiceProduct from '@/components/home/ChoiceProduct.vue'
import BackTop from '@/components/common/BackTop.vue'
import { getSlideList, getMenuList } from '@/api/home'
import { getCouponCollectionList } from '@/api/couponCollection'
import { couponList } from '@/util/plan'
import { linkToPromotion } from '@/util'
import moment from 'moment'
moment.locale('zh-cn', {
  // meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
  meridiem: function(hour, minute) {
    const hm = hour * 100 + minute
    if (hm < 600) {
      return '凌晨'
    } else if (hm < 900) {
      return '早上'
    } else if (hm < 1130) {
      return '上午'
    } else if (hm < 1230) {
      return '中午'
    } else if (hm < 1800) {
      return '下午'
    } else {
      return '晚上'
    }
  }
})
export default {
  components: {
    SubTitle,
    DiscountCoupon,
    // eslint-disable-next-line vue/no-unused-components
    ChoicenessList,
    CompleteInfoPopup,
    BackTop,
    ChoiceProduct
  },
  setup() {
    const router = useRouter()
    let store = useStore()
    const meridiemStr = moment(new Date()).format('A')
    // console.log('meridiemStr--', meridiemStr)
    const state = reactive({
      domain: store.state.staticDomain,
      meridiemStr,
      choiceProductTitle: {
        title: '',
        more: '全部商品',
        showBorder: false
      },
      ticket: {
        title: '精选优惠券',
        more: '更多好券',
        showBorder: true
      },
      couponList: [],
      menuLis: []
    })

    let getMenuListFn = async () => {
      try {
        let list = await getMenuList()
        state.menuLis = list.map(item => ({ ...item, path: '/shop' }))
      } catch (error) {
        state.menuLis = []
      }
    }
    const getCoupon = async () => {
      let parmas = {
        pageNo: '1',
        indexShowFlag: 1,
        pageSize: '10000'
      }
      let { list } = await getCouponCollectionList(parmas)
      state.couponList = couponList(list)
    }
    const linkTo = (path, query) => {
      router.push({ path, query })
    }
    // 跳转到活动促销页面
    const toPromotion = () => {
      linkToPromotion('events')
    }
    const registerUserInfo = computed(() => store.state.registerUserInfo)
    const username = computed(() => registerUserInfo.value?.username || '')
    onMounted(async () => {
      getMenuListFn()
      getCoupon()
    })
    return {
      ...toRefs(state),
      linkTo,
      toPromotion,
      username
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  background: #f6f6f6;
  height: 100%;
  :deep(.noBorder .more) {
    border-bottom: none;
  }
  padding-bottom: calc(60px + constant(safe-area-inset-bottom));
  padding-bottom: calc(60px + env(safe-area-inset-bottom));
}

.link {
  width: 50%;
  flex-direction: column;
  font-size: 14px;
  padding: 13px 0;
  background: #fff;
  position: relative;
  img {
    width: 26px;
    height: 26px;
    margin-bottom: 8px;
  }
}
.borderRight::after {
  content: '';
  position: absolute;
  top: 13px;
  right: 0;
  width: 2px;
  height: 50px;
  background: url('../../assets/images/dotted.png');
}
.welcome {
  margin: 10px;
  padding-left: 15px;
  line-height: 40px;
  color: #333;
  border-radius: 5px;
  background-color: #fff;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.choiceBox {
  padding: 10px;
}
.bottomContent {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 10px 10px;
  background-color: #fff;
}
.planBanner {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 20px 0px;
  img {
    width: 100%;
    height: 96px;
    padding-top: 8px;
  }
}
.search {
  position: fixed;
  left: 0;
  top: 132px;
  background: rgba(0, 0, 0, 0.5);
  padding: 9px 16px 7px 24px;
  border-radius: 0 40px 40px 0;
  z-index: 100;
  img {
    width: 24px;
    height: 24px;
  }
}
</style>
